module.exports = __webpack_public_path__ + "img/user-avatar1.655644f9.png";